import React from 'react';
import PropTypes from 'prop-types';

export default class OurTeamList extends React.Component {
    render() {
        const {key, className, team} = this.props;

        return <div className="bios-list">
            {team && team.map(bio => <div className="bio"  key={`bio-list-id-${bio.id}`}>
                <p>
                    {bio.href ? <a href={bio.href}><img src={bio.thumb} alt={bio.title}/></a> : <img src={bio.thumb} alt={bio.title}/>}
                </p>

                {bio.href ? <p className="title"> <a href={bio.href}>{bio.title}</a></p> : <p className="title">{bio.title}</p>}

                {bio.position && <p>
                    {bio.position}
                </p>}
            </div>)}
        </div>;
    }
}

OurTeamList.propTypes = {
    key: PropTypes.string,
    team: PropTypes.array.isRequired,
    className: PropTypes.string
}

OurTeamList.defaultProps = {
    key: '',
    team: [],
    className: ''
}